import './TrustedMe.css';

const importAll = (r) => {
	const images = {};
	r.keys().forEach((item, index) => {
		images[item.replace('./', '')] = r(item);
	});
	return images;
};

const svgElements = importAll(require.context('./assets/icons', false, /\.(png|jpeg|svg)$/));

const TrustedMe = () => {
	return (
		<div className="trusted-me">
			<h1>Zaufali mi</h1>
			<div className="items">
				{Object.values(svgElements).map((key, index) => {
					return (
						<div className="item">
							<img src={key}></img>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default TrustedMe;
